<script lang="ts">
    import type {SearchHistoryEntryDto} from 'typings/portaro.be.types';
    import {onMount} from 'svelte';
    import {getInjector} from 'core/svelte-context/context';
    import {KpSearchHistoryService} from './kp-search-history.service';
    import {exists} from 'shared/utils/custom-utils';
    import KpLoadablePageContainer from 'shared/layouts/KpLoadablePageContainer.svelte';
    import SearchHistoryHeadingPart from './parts/SearchHistoryHeadingPart.svelte';
    import SearchHistoryTwoColumnLayoutPart from './parts/SearchHistoryTwoColumnLayoutPart.svelte';

    const service = getInjector().getByToken<KpSearchHistoryService>(KpSearchHistoryService.serviceName);

    let loading = true;
    let searchHistory: SearchHistoryEntryDto[] | null = null;

    onMount(async () => {
        searchHistory = await service.getSearchHistory();
        loading = false;
    });
</script>

<KpLoadablePageContainer pageClass="kp-search-history-page"
                         loadError="{!loading && !exists(searchHistory)}"
                         {loading}>

    <SearchHistoryHeadingPart/>
    <SearchHistoryTwoColumnLayoutPart {searchHistory}/>
</KpLoadablePageContainer>